import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import service from './Service'

export const getNewsTypeThunk = createAsyncThunk(
  'common/news/getNewsTypeThunk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await service.getNewsType(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getSentimentsThunk = createAsyncThunk(
  'common/news/getSentimentsThunk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await service.getSentiments(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
